import React, { useEffect, useRef, useState } from "react";
import imgHis from "../../../../assets/images/Event-2025/his.png";
import imgTitle from "../../../../assets/images/Event-2025/title-tree.png";
import imgReindeer from "../../../../assets/images/Event-2025/image 30.png";
import imgMoon from "../../../../assets/images/Event-2025/moon.png";
import iconGiftNormal from "../../../../assets/images/Event-2025/gift.svg";
import iconGiftSuper from "../../../../assets/images/Event-2025/gift-super.svg";
import imgSnowman from "../../../../assets/images/Event-2025/snowman.png";
import "./index.scss";
import moment from "moment/moment";
import { Empty, Table } from "antd";
import PopupComponentError from "../components/Popup/PopupComponentError";
import iconTh from "../../../../assets/images/Event-2025/image 91.png";
import iconNgSuccess from "../../../../assets/images/Event-2025/image 92.png";
import iconNgError from "../../../../assets/images/Event-2025/Frame 124.png";
import iconBid from "../../../../assets/images/Event-2025/291310-P7M4UY-325-01 1.png";
import iconSpe from "../../../../assets/images/Event-2025/Group 120 (1).png";
import iconErrorDiem from "../../../../assets/images/Event-2025/icon-error-diem.png";
import iconErrorPhao from "../../../../assets/images/Event-2025/Asset 4@4x (2).png";
import iconGoodLuck from "../../../../assets/images/Event-2025/image 93.png";
import iconErrorGiftSmail from "../../../../assets/images/Event-2025/Frame (5).png";
import iconErrorGiftSuper from "../../../../assets/images/Event-2025/Group (6).png";
import iconErrorGiftAll from "../../../../assets/images/Event-2025/Frame (6).png";
import iconGiftSmail from "../../../../assets/images/Event-2025/icon-num-nomal.png";
import iconSuper from "../../../../assets/images/Event-2025/icon-num-super.png";
import titleTree from "../../../../assets/images/Event-2025/100-winners.png";
// import PopupChristmasBox from "../components/Popup/PopupChristmasBox";
import { useTranslation } from "react-i18next";
// new
import { getCheckStatusEvent, getHistoryEventNoel } from "dataLayer/product";
import { useQuery } from "react-query";
import { isLoggedIn } from "@utils/cookie";
import { useStartOpenEventNoel } from "dataLayer/user";
import PopupComponentOpenHistory from "../components/Popup/PopupComponentOpenHistory";
import PopupChristmasBox from "../components/Popup/PopupChristmasBox";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PATHS } from "@config/constants";
import styled from "styled-components";
const TYPE_GIFT = {
  normal: 0,
  supper: 1,
};

export default function ChristmasTree({ setOpenModalLogin }) {
  const history = useHistory();
  const { t } = useTranslation();

  const dataPopup = useRef({
    imgMain: "",
    imgLeft: "",
    imgRight: "",
    contentHeader: "",
    descriptionHeader: "",
    descriptionFooter: "",
    contentAction: "",
    isFailsAll: false,
    action: () => {},
  });
  const [open, setOpen] = useState(false);
  const [openPopupBox, setOpenPopupBox] = useState(false);
  const [idBox, setIdBox] = useState(0);
  const [openPopupHis, setOpenPopupHis] = useState(false);
  const isLoadingSuperGift = useRef(false);
  // new
  const { data: historyEventNoel = {}, refetch } = useQuery(
    getHistoryEventNoel()
  );
  const { data: statusEvent, refetch: refetchStatus } = useQuery(
    getCheckStatusEvent()
  );
  const {
    mutate: mutateOpenGift,
    data,
    isSuccess,
    error,
    isLoading: isLoadingOpenGift,
  } = useStartOpenEventNoel();
  const { resultHistory = [], resultSpeHis = [] } = historyEventNoel;

  const handleGetDataHistory = () => {
    // dispatch(getHistoryOpenGiftNoelSpecial());
  };

  // const selectorProduct = useSelector(curStateHome)
  // let currentProduct = selectorProduct.bidProduct.filter(
  //   (product) => new Date(product?.start_time).getTime() < currentDate
  // );

  useEffect(() => {
    handleGetDataHistory();
  }, []);

  const handleGetTextRemainSpecial = () => {
    const remain = resultSpeHis.length;
    const totalSpecial = 10;
    if(remain == 0){
      return 'Las 10 Gifcards aún estan en juego! ¡Desenvuelve las Cajas Navideñas ahora para ser el primer ganador!';
    }else if(remain == 9){
      return 'Una Gifcard de S/.100 aún está en juego! ¡Desenvuelve las Cajas Navideñas ahora para ser el gran ganador!';
    }else if (remain > 0 && remain < totalSpecial){
      return `${totalSpecial - remain} Gifcards de S/.100 siguen en juego! ¡Desenvuelve las Cajas Navideñas ahora para ser el gran ganador!`;
    }else{
      return 'Las 10 Gifcards ya tienen ganador. ¡Enciende más Fuegos artificiales para llevarte 3 premios especiales!';
    }
  };

  const handleCheckLogin = () => {
    // const isCheckLogin = selectorAccount.userInfo;
    // if (!isCheckLogin) {
    //   setOpenModalLogin(true);
    //   return false;
    // }

    return true;
  };

  const columns = [
    {
      title: `No`,
      dataIndex: "key",
      key: "key",
      width: 60,
      render: (_, record) => {
        return <div>{+_ + 1}</div>;
      },
    },
    {
      title: `ISDN`,
      dataIndex: "isdn",
      key: "isdn",
    },
    {
      title: `Tiempo`,
      dataIndex: "open_time",
      key: "open_time",
      render: (_ = "", record) => {
        const datePart = moment(_).format("YYYY-MM-DD");
        const timePart = moment(_).format("HH:mm:ss");
        return (
          <div className="timer-table-history">
            <div>{datePart || ""}</div>
            <div>{timePart || ""}</div>
          </div>
        );
      },
    },
  ];

  const afterOpenGift = (data, isLoading, dataError = null) => {
    if (data) {
      if (data?.success) {
        console.log(data);
        const numberAdd = data?.data?.award?.value;
        setOpen(true);
        const typeGift = data?.data?.award?.type;
        switch (typeGift) {
          case "SPECIAL":
            console.log("SPECIAL");
            dataPopup.current = {
              imgMain: iconSpe,
              imgLeft: iconNgSuccess,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.congrats")}`,
              descriptionHeader: `${t("event_new_year.you_won_a_prize")}`,
              descriptionFooter: `${t("event_new_year.you_can_open_more")}`,
              contentAction: `${t("event_new_year.close")}`,
              isFailsAll: false,
              action: () => setOpen(false),
            };
            handleGetDataHistory();
            break;
          case "BID_FREE":
            console.log("BID_FREE");
            dataPopup.current = {
              imgMain: iconBid,
              imgLeft: iconNgSuccess,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.congrats")}`,
              // descriptionHeader: `အခမဲ့လေလံ ${numberAdd} ခုကို ရရှိပါပြီ။ ယခုအပတ်တွင် ${currentProduct[0]?.product_name} ကိုအနိုင်ရရှိရန် လေလံများများတင်ပြီး Fireworksများကို စတင်ရန် မီးခြစ်ဆံများထပ်မံရယူလိုက်ပါ။`,
              descriptionFooter: `${t("event_new_year.winning_tip")}`,
              contentAction: `${t("event_new_year.bid_now")}`,
              isFailsAll: false,
              // action: () => navigate(`${PATH.BID}/${urlPageBid.running}`),
            };
            // dispatch(getTurnRemain({}))
            break;
          case "SPARK":
            console.log("Tia lửa");
            dataPopup.current = {
              imgMain: iconErrorDiem,
              imgLeft: iconNgSuccess,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.congrats")}`,
              descriptionHeader: ` မီးခြစ်ဆံများ ${numberAdd} ခု ရရှိပါပြီ Firework Shells များပိုမိုရရှိရန် Packages များကိုဝယ်ယူပြီး Fireworks ကိုယခုစတင်လိုက်ပါ။`,
              descriptionFooter: `${t(
                "event_new_year.bigger_packages_give_more_Firework_Shells"
              )}`,
              contentAction: `${t("event_new_year.buy_packages")}`,
              isFailsAll: false,
              // action: () => navigate(PATH.PACKAGE),
            };
            break;
          case "SHELL":
            console.log("Tia lửa");
            dataPopup.current = {
              imgMain: iconErrorPhao,
              imgLeft: iconNgSuccess,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.congrats")}`,
              descriptionHeader: `Firework Shells ${numberAdd} ခု ရရှိပါပြီ။ Firework ကိုယခုစတင်ရန်  မီးခြစ်ဆံများပိုမိုရရှိရန် ယခုပဲ လေလံဆွဲပါ။`,
              descriptionFooter: `${t(
                "event_new_year.each_bid_will_randomly_receive_1_5_matches"
              )}`,
              contentAction: `${t("event_new_year.bid_now")}`,
              isFailsAll: false,
              // action: () => navigate(`${PATH.BID}/${urlPageBid.running}`),
            };
            break;
          case "GOOD_LUCK":
            console.log("GOOD_LUCK");
            dataPopup.current = {
              imgMain: iconGoodLuck,
              imgLeft: iconNgError,
              imgRight: iconTh,
              contentHeader: `${t("event_new_year.oops")}`,
              descriptionHeader: `${t(
                "event_new_year.you_found_a_Golden_Bell"
              )}`,
              contentAction: `${t("event_new_year.close")}`,
              isFailsAll: false,
              strokeWidth: 3,
              action: () => setOpen(false),
            };
            break;
          default:
            break;
        }

        // dispatch(getConfigEventNewYear2024());
      }
    }

    if (!isLoading) {
      isLoadingSuperGift.current = false;
    }
  };

  const handleOpenGift = (type = TYPE_GIFT.normal, name = "") => {
    const isLogin = isLoggedIn();
    if (!isLogin) {
      return setOpenModalLogin(true);
    }

    if (isLoadingOpenGift) {
      return;
    }

    if (!statusEvent.open_left && !statusEvent.open_super_left) {
      console.log("hết cả 2 loại quà");
      dataPopup.current = {
        imgMain: iconErrorGiftAll,
        imgLeft: iconNgError,
        imgRight: iconTh,
        contentHeader: `${t("event_new_year.oops")}`,
        descriptionHeader: `¡Te has quedado sin Cajas Navideñas! ¡Inicia sesión mañana para reclamar 3 Cajas Navideñas Normales GRATIS o enciende un Espectáculo de Fuegos Artificiales en hitos (50, 100 y más) para desbloquear Súper Cajas Navideñas con más recompensas premium!`,
        descriptionFooter: `La Súper Caja Navideña es la caja AMARILLA. La caja BLANCA es la Caja Navideña normal`,
        contentAction: `Cerrar`,
        isFailsAll: false,
        strokeWidth: 3,
        action: () => setOpen(false),
      };
      return setOpen(true);
    }

    if (!statusEvent.open_left && type === TYPE_GIFT.normal) {
      console.log("hêt hộp quà nhỏ");
      dataPopup.current = {
        imgMain: iconErrorGiftSmail,
        imgLeft: iconNgError,
        imgRight: iconTh,
        strokeWidth: 3,
        descriptionHeader: `¡Te has quedado sin Cajas Navideñas Normales! Abra una Súper Caja Navideña ahora o inicia sesión mañana para recibir 3 Cajas Navideñas Normales GRATIS`,
        descriptionFooter: `La Súper Caja Navideña es la caja AMARILLA. La caja BLANCA es la Caja Navideña normal`,
        contentAction: `${t("event_new_year.close")}`,
        isFailsAll: false,
        action: () => setOpen(false),
      };
      return setOpen(true);
    }

    if (!statusEvent.open_super_left && type === TYPE_GIFT.supper) {
      console.log("hết hộp quà super");
      dataPopup.current = {
        imgMain: iconErrorGiftSuper,
        imgLeft: iconNgError,
        imgRight: iconTh,
        strokeWidth: 3,
        descriptionHeader: `¡Te has quedado sin Súper Cajas Navideñas! ¡Abre una Caja Navideña Normal o alcanza la meta del Espectáculo de Fuegos Artificiales (50, 100 y más) para obtener más Súper Cajas Navideñas llenas de recompensas premium!`,
        descriptionFooter: `La Súper Caja Navideña es la caja AMARILLA. La caja BLANCA es la Caja Navideña normal`,
        contentAction: `${t("event_new_year.close")}`,
        isFailsAll: false,
        action: () => setOpen(false),
      };
      return setOpen(true);
    }

    isLoadingSuperGift.current = true;
    // thành công
    const isSuper = type === TYPE_GIFT.supper ? true : false;
    mutateOpenGift(
      { isSuper: isSuper },
      {
        onSuccess: (data) => {
          if (data.data.award) {
            const numberAdd = data?.data?.award?.value;
            refetch();
            refetchStatus();

            switch (data.data.award.type) {
              case "SPARK":
                // tia lửa
                dataPopup.current = {
                  imgMain: iconErrorDiem,
                  imgLeft: iconNgSuccess,
                  imgRight: iconTh,
                  contentHeader: 'Congrats!',
                  descriptionHeader: `Conseguiste ${numberAdd} Fósforos! ¡Compra más paquetes para encender más Fuegos Artificiales para iluminar la noche con un colorido Espectáculo de Fuegos Artificiales!`,
                  descriptionFooter: `Los paquetes más grandes incluyen más Conchas de fuegos artificiales`,
                  contentAction: `Compra paquetes`,
                  isFailsAll: false,
                  action: () => history.push(PATHS.ACCOUNT_PAGE, { isPagePack: true })
                };
                break;
              case "BID_FREE":
                console.log("BID_FREE");
                dataPopup.current = {
                  imgMain: iconBid,
                  imgLeft: iconNgSuccess,
                  imgRight: iconTh,
                  contentHeader: 'Congrats!',
                  descriptionHeader: `¡Has desbloqueado ${numberAdd} Pujas Gratis! ¡Haz tus pujas ahora para ganar un premio de alto valor esta semana y recolecta más fósforos para encender los Fuegos Artificiales ahora!`,
                  descriptionFooter: `Tip Ganador: ¡Haz la puja más baja y única!!!`,
                  contentAction: `Puja ahora`,
                  isFailsAll: false,
                  action: () => history.push(PATHS.BID2_PAGE),
                };
                // dispatch(getTurnRemain({}))
                break;
              case "SHELL":
                console.log("Vỏ pháo");
                dataPopup.current = {
                  imgMain: iconErrorPhao,
                  imgLeft: iconNgSuccess,
                  imgRight: iconTh,
                  contentHeader: 'Congrats!',
                  descriptionHeader: `¡Encontraste ${numberAdd} Fuegos Artificiales! ¡Haz una puja ahora para reunir más fósforos y hacer que tus Fuegos Artificiales sean aún más mágicos!`,
                  descriptionFooter: `Cada puja recibirá aleatoriamente entre 1 y 5 Fósforos.`,
                  contentAction: `Puja ahora`,
                  isFailsAll: false,
                  action: () => history.push(PATHS.BID2_PAGE),
                };
                break;
              case "GOOD_LUCK":
                console.log("GOOD_LUCK");
                dataPopup.current = {
                  imgMain: iconGoodLuck,
                  imgLeft: iconNgError,
                  imgRight: iconTh,
                  contentHeader: 'OOPS!',
                  descriptionHeader: `¡Encontraste la Campana Dorada! Buena suerte: Inténtalo de nuevo para tener otras oportunidades de ganar algo mágico...`,
                  contentAction: `Cerrar`,
                  isFailsAll: false,
                  strokeWidth: 3,
                  action: () => setOpen(false),
                };
                break;
              case "SPECIAL":
                console.log("SPECIAL");
                dataPopup.current = {
                  imgMain: iconSpe,
                  imgLeft: iconNgSuccess,
                  imgRight: iconTh,
                  contentHeader: 'Congrats!',
                  descriptionHeader: `¡Felicitaciones! 🎉Has ganado una Giftcard de S/.100. ¡Bitel se comunicará contigo pronto para la entrega de tu premio!
¡Sigue jugando que te esperan más sorpresas!`,
                  descriptionFooter: `Puedes abrir más de 1 premio de S/.100. ¡Sigue abriendo premios diariamente!`,
                  contentAction: `Cerrar`,
                  isFailsAll: false,
                  action: () => setOpen(false),
                };
                handleGetDataHistory();
                break;
              default:
                break;
            }
            setOpen(true);
            // mở hộp quà thành công
          }
          
        },
        onError: (error) => {
          console.error("Mutation failed:", error);
        },
      }
    );
  };

  const handleOpenDetailBox = (type) => {
    setOpenPopupBox(true);
    setIdBox(type);
  };
  const handleOpenHis = () => {
    setOpenPopupHis(true);
  };

  return (
    <Div className="event-2024-tab-tree">
      {openPopupHis &&
      <PopupComponentOpenHistory
        open={openPopupHis}
        setOpen={setOpenPopupHis}
        data={dataPopup.current}
      />}
      <PopupComponentError
        open={open}
        setOpen={setOpen}
        data={dataPopup.current}
        isGetContainer
      />
      <div className="tree_top">
        <div className="tree_top_title">
          <div onClick={handleOpenHis}>
            <img src={imgHis} alt="" className="zoom-in-out-component" />
          </div>
          <div>
            <img src={imgTitle} alt="" />
          </div>
          <div>
            <img src={imgReindeer} alt="" />
          </div>
        </div>
        <img className="moon" src={imgMoon} alt="" />
      </div>
      <div className="tree_content">
        <div className="tree_gift_group">
          <div className="tree_gift_bg">
            <div className="tree_gift_list">
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_1")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_2")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_3")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_4")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_5")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_6")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>
              <div
                className="gift_normal zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.normal, "gift_7")}
              >
                <img src={iconGiftNormal} alt="" />
              </div>

              <div
                className="gift_super zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.supper, "gift_8")}
              >
                <img src={iconGiftSuper} alt="" />
              </div>
              <div
                className="gift_super zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.supper, "gift_9")}
              >
                <img src={iconGiftSuper} alt="" />
              </div>
              <div
                className="gift_super zoom-in-out-box"
                onClick={() => handleOpenGift(TYPE_GIFT.supper, "gift_10")}
              >
                <img src={iconGiftSuper} alt="" />
              </div>
            </div>
          </div>
          <div className="tree_gift_num">
            <p>
              {" "}
              {(statusEvent?.open_super_left || 0) > 0 || (statusEvent?.open_left || 0) > 0 ? (
                <span>
                  Te quedan{" "}
                  {statusEvent?.open_super_left || 0} Súper Cajas Navideñas{" "}
                  y {statusEvent?.open_left || 0}{" "}
                  {statusEvent?.open_left === 1 ? "Caja Navideña normal." : "Cajas Navideñas normales."}
                </span>
              ) : (
                <span>Has usado todas las Cajas Navideñas disponibles.</span>
              )}
            </p>
            <div className="num_open_gift">
              <div className="num_open_item">
                <img
                  className="img_super cursor-pointer"
                  src={iconSuper}
                  alt=""
                  onClick={() => handleOpenDetailBox(2)}
                />
                <span
                  className="num_super"
                  onClick={() => handleOpenDetailBox(2)}
                >
                  {statusEvent?.open_super_left || 0}
                </span>
              </div>
              <div className="num_open_item">
                <img
                  className="img_normal cursor-pointer"
                  src={iconGiftSmail}
                  alt=""
                  onClick={() => handleOpenDetailBox(1)}
                />
                <span
                  className="num_normal"
                  onClick={() => handleOpenDetailBox(1)}
                >
                  {statusEvent?.open_left || 0}
                </span>
              </div>
            </div>
          </div>
          <p className="text_bot_open">
            ¡Abre una caja navideña y sorpréndete con fantásticas recompensas festivas!
          </p>
        </div>
        <div className="tree_winner">
          <img className="title_tree_winner" src={titleTree} alt="" />
          <Table
            columns={columns}
            dataSource={resultSpeHis}
            pagination={false}
            className="table_winner"
            locale={{
              emptyText: (
                <Empty
                  description={
                    <span style={{ color: "black", fontSize: "16px" }}>
                      Sin datos
                    </span>
                  }
                />
              ),
            }}
          />
          <p className="text_remain_special">{handleGetTextRemainSpecial()}</p>
        </div>
      </div>
      <div className="snowman">
        <img src={imgSnowman} alt="" />
      </div>

      <PopupChristmasBox
        open={openPopupBox}
        setOpen={setOpenPopupBox}
        idBox={idBox}
      />
    </Div>
  );
}

const Div = styled.div`
@media (max-width: 576px) {
    .snowman{
      max-width: 85px;
      display: none;
    }

    .text_remain_special {
        right: 0;
        max-width: 90%;
        font-size: 12px;
        margin: 0 auto;
    }
  }
`
